/**
 * 上传体积上限的**单一源**(2026-09-21 日志体检批)。
 *
 * ★这几个数**由基建/后端决定,不是产品选的**。前端写得比它们大 = 把一个 413 白页留给用户
 *   (nginx 直接回 HTML,请求根本到不了 backend,后端日志里连一行都没有);写得比它们小 = 白白拒收。
 *
 * ★★ 0921 三台只读核对 —— **边缘 nginx 的上限三台不一样**:
 *   · 生产 `/etc/nginx/conf.d/gscq.conf` server 级与 `location /api/` 都是 **220m**
 *     (配置里自己写着推导:「前端承诺单文件 200MB」,nginx 量的是整个请求体,所以留 20m 给 multipart 开销);
 *   · 测试机 `/etc/nginx/conf.d/gscq-test.conf` 是 **100m**(比生产紧,属环境没对齐,不是产品口径)。
 *     实锤:`test-error.log` 0921 17:58:18 `client intended to send too large body: 166065829 bytes,
 *     request: "POST /api/v1/tenant/knowledge/upload"`;
 *   · backend Spring multipart max-file-size **200MB**。
 *   所以这里的数字取**产品承诺、也是生产真实口径的 200**。测试机那堵更矮的墙不进代码 ——
 *   照它改就会在生产上白白拒收 100~200MB 的合法文件;该做的是把测试机 nginx 对齐生产。
 * ★因为「哪堵墙先落下」随环境不同,**nginx 那层的 413 兜底话术不带数字**(见下);
 *   带数字的话术只给有确定业务上限的入口用(知识库 50MB、海报 10MB,都是后端自己的闸,三台一致)。
 */

/** 单文件上传的产品承诺上限(MB)= 生产边缘 nginx 220m 扣掉 multipart 开销 = backend multipart 200MB。 */
export const NGINX_MAX_UPLOAD_MB = 200;

/**
 * 「文件太大」的统一话术。各处前置校验与 413 兜底**共用这一句**,用户不会因为拦在哪一层
 * 而听到两种说法;`limitMb` 各自传自己那层的真实上限(别拿 nginx 的 100 去说一个 10MB 的闸)。
 */
export function uploadTooLargeMessage(limitMb: number, fileName?: string): string {
  const who = fileName ? `《${fileName}》` : "文件";
  return `${who}太大,超过了上传上限(${limitMb}MB),请压缩后再传`;
}

/**
 * HTTP 413 兜底话术 —— 走到这里说明是 nginx 那层拦的(后端自己的 413 带 JSON 信封,有它自己的数字)。
 * ★不带数字:边缘 nginx 的上限随环境不同(生产 220m / 测试机 100m),这里报哪个数都可能是错的,
 *   而用户会照着错的数字去压文件。
 */
export const PAYLOAD_TOO_LARGE_MESSAGE = "文件太大,超过了服务器的上传上限,请压缩后再传";
